import { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { CSSTransition } from "react-transition-group";

import Header from "../components/Header";
import Inbound from "../components/Inbound";
import Footer from "../components/Footer";

import style from "./index.module.css";
import popup from "../components/Popup.module.css";
import "./index.css";

import main1 from "../img/front/1.png";
import main2 from "../img/front/2.png";
import main3 from "../img/front/3.png";
import main4 from "../img/front/4.png";
import main5 from "../img/front/5.png";
import main6 from "../img/front/6.png";
import main7 from "../img/front/7.png";
import main8 from "../img/front/8.png";
import main9 from "../img/front/9.png";
import main10 from "../img/front/10.png";

import logo1 from "../img/logos/logo-1.png";
import logo2 from "../img/logos/logo-2.png";
import logo3 from "../img/logos/logo-3.png";
import logo4 from "../img/logos/logo-4.png";
import logo5 from "../img/logos/logo-5.png";
import logo6 from "../img/logos/logo-6.png";
import logo7 from "../img/logos/logo-7.png";
import logo8 from "../img/logos/logo-8.png";
import logo9 from "../img/logos/logo-9.png";
import logo10 from "../img/logos/logo-10.png";
import logo11 from "../img/logos/logo-11.png";
import logo12 from "../img/logos/logo-12.png";
import logo13 from "../img/logos/logo-13.png";
import logo14 from "../img/logos/logo-14.png";
import logo15 from "../img/logos/logo-15.png";
import logo16 from "../img/logos/logo-16.png";
import logo17 from "../img/logos/logo-17.png";
import logo18 from "../img/logos/logo-18.png";

import bg1 from "../img/1.png";
import bg2 from "../img/2.png";
import bg3 from "../img/3.png";
import bg4 from "../img/4.png";
import bg5 from "../img/5.png";
import bg6 from "../img/6.png";

import section1 from "../img/x-concep.png";
import section2 from "../img/fajob.png";

import ImagePopupGroup from "../components/Imgpopup";
import {
    FALLBACK_HISTORY_CONFIG,
    FALLBACK_POPUP_CONFIG,
    HistoryConfig,
    PopupConfig,
    fetchHistoryConfig,
    fetchPopupConfig,
} from "../cms/siteConfig";

export default () => {
    const head = useRef<HTMLHeadingElement | null>(null);
    const unitRoot = useRef<HTMLDivElement | null>(null);
    const unit1 = useRef<HTMLDivElement | null>(null);
    const unit2 = useRef<HTMLDivElement | null>(null);
    const unit3 = useRef<HTMLDivElement | null>(null);
    const unit3text1 = useRef<HTMLHeadingElement | null>(null);
    const unit3text2 = useRef<HTMLHeadingElement | null>(null);
    const unit3text3 = useRef<HTMLHeadingElement | null>(null);
    const unit3button1 = useRef<HTMLAnchorElement | null>(null);

    window.addEventListener("scroll", (e) => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        let windowHeight = window.innerHeight;

        if (!head.current) return;
        if (!unitRoot.current) return;
        if (!unit1.current) return;
        if (!unit2.current) return;
        if (!unit3.current) return;
        if (!unit3text1.current || !unit3text2.current || !unit3text3.current || !unit3button1.current) return;

        if (scrollTop < windowHeight) {
            unitRoot.current.style.backgroundColor = `rgba(0,0,0,${tween(scrollTop, 0, windowHeight * 0.8, 50) / 100})`;
            head.current.style.transform = `translateY(-${tween(
                scrollTop,
                0,
                windowHeight / 2,
                head.current.offsetHeight / 2
            )}px)`;
        } else {
            unitRoot.current.style.backgroundColor = `rgba(0,0,0,0.5)`;
            head.current.style.transform = `translateY(-${head.current.offsetHeight / 2}px)`;
        }

        if (scrollTop < windowHeight) {
            unit1.current.style.opacity = `${tween(scrollTop, windowHeight * 0.5, windowHeight, 100) / 100}`;
        } else if (scrollTop < windowHeight * 2) {
            unit1.current.style.opacity = `${(100 - tween(scrollTop, windowHeight * 1.2, windowHeight * 1.5, 100)) / 100
                }`;

            unit2.current.style.opacity = `${tween(scrollTop, windowHeight * 1.5, windowHeight * 2, 100) / 100}`;
        } else if (scrollTop < windowHeight * 3) {
            unit2.current.style.opacity = `${(100 - tween(scrollTop, windowHeight * 2.2, windowHeight * 2.5, 100)) / 100
                }`;
            unit3.current.style.opacity = `${tween(scrollTop, windowHeight * 2.5, windowHeight * 3, 100) / 100}`;
            // unit3text1.current.style.transform = `translateY(${unit3text1.current.offsetHeight / 2}px)`;
            unit3text2.current.style.opacity = "0";
            unit3text3.current.style.opacity = "0";
            unit3button1.current.style.opacity = "0";
        } else if (scrollTop < windowHeight * 5.5) {
            unit3.current.style.opacity = "1";
            // unit3text1.current.style.transform = `translateY(${
            //     unit3text1.current.offsetHeight / 2 -
            //     tween(scrollTop, windowHeight * 3.5, windowHeight * 4, unit3text1.current.offsetHeight / 2)
            // }px)`;
            unit3text2.current.style.opacity = `${tween(scrollTop, windowHeight * 3.2, windowHeight * 3.6, 100) / 100}`;
            unit3text3.current.style.opacity = `${tween(scrollTop, windowHeight * 3.5, windowHeight * 3.9, 100) / 100}`;
            unit3button1.current.style.opacity = `${tween(scrollTop, windowHeight * 3.8, windowHeight * 4.3, 100) / 100
                }`;
        } else {
            // unit3text1.current.style.transform = "translateY(0px)";
            unit3text2.current.style.opacity = "1";
            unit3text3.current.style.opacity = "1";
            unit3button1.current.style.opacity = "1";
        }
    });

    const inbound = useRef<HTMLDivElement | null>(null);
    const [openInbound, setOpenInbound] = useState<boolean>(false);
    const [popupConfig, setPopupConfig] = useState<PopupConfig>(FALLBACK_POPUP_CONFIG);
    const [isPopupConfigLoaded, setIsPopupConfigLoaded] = useState<boolean>(false);

    useEffect(() => {
        let active = true;

        fetchPopupConfig()
            .then((nextConfig) => {
                if (!active) return;
                setPopupConfig(nextConfig);
            })
            .catch(() => {
                // fetchPopupConfig 내부에서 fallback을 반환하지만,
                // 예외 상황에서도 로딩 완료 플래그는 해제되어야 한다.
            })
            .finally(() => {
                if (!active) return;
                setIsPopupConfigLoaded(true);
            });

        return () => {
            active = false;
        };
    }, []);

    const displayPopups = useMemo(() => {
        if (!isPopupConfigLoaded) return [];

        return popupConfig.popups
            .map((popupItem, index) => ({ popupItem, index }))
            .filter(({ popupItem }) => popupItem.enabled === true && popupItem.imageUrl)
            .sort((a, b) => {
                const aTime = Date.parse(a.popupItem.createdAt || "") || 0;
                const bTime = Date.parse(b.popupItem.createdAt || "") || 0;

                if (aTime !== bTime) return aTime - bTime;
                return a.index - b.index;
            })
            .map(({ popupItem }) => popupItem);
    }, [isPopupConfigLoaded, popupConfig.popups]);

    return (
        <>
            <div>
                <Header />
                <div className={style["container--front"]}>
                    <div className={style["unit--front--cover"]}>
                        <Slidshow />
                    </div>
                    <div ref={unitRoot} className={style["unit--front--contents"]}>
                        <div className={style["unit--front--head"]}>
                            <div className={style["unit--front--content"]} style={{ opacity: 1 }}>
                                <h4 ref={head} className={style["text--front--head"]}>
                                    From Idea to Reality
                                    <br />
                                    AI-Driven Manufacturing
                                </h4>
                            </div>
                        </div>
                        <div ref={unit1} className={style["unit--front--content"]}>
                            <h4 className={style["text--front--copy"]}>
                                제조 DNA & AI 기술의 불가능을 가능하게 만듭니다
                            </h4>
                        </div>
                        <div ref={unit2} className={style["unit--front--content"]}>
                            <h4 className={style["text--front--copy"]}>
                                텍스트 한 줄이 완성된 3D 모델로 변하는 혁신을 경험하세요
                            </h4>
                        </div>
                        <div ref={unit3} className={style["unit--front--content"]}>
                            <div className={style["unit--front--action"]}>
                                <h4 ref={unit3text1} className={style["text--front--copy"]}>
                                    당신의 아이디어를 현실로 만드는 완벽한 기술 파트너
                                </h4>
                                <h4
                                    ref={unit3text2}
                                    className={[style["text--front--logo"], style["text--front--logo--slogan"]].join(
                                        " "
                                    )}
                                >
                                    <b>T</b>ECHNOLOGY <b>B</b>Y <b>H</b>UMAN
                                </h4>
                                <h4 ref={unit3text3} className={style["text--front--logo"]}>
                                    THE ENGINEER
                                </h4>
                                {/* <button
                                    ref={unit3button1}
                                    className={style["button--front"]}
                                    onClick={() => setOpenInbound(true)}
                                >
                                    지금 시작하기
                                </button> */}
                                <a
                                    ref={unit3button1}
                                    className={style["button--front"]}
                                    href="https://xconcepai.com/"
                                    target="_blank"
                                >
                                    지금 시작하기
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <Partners />
                <div
                    className={style["container--about"]}
                    style={{ background: "linear-gradient(135deg, #111 0%, #000 100%)" }}
                >
                    <div className={style["wrapper--about"]}>
                        <div className={style["unit--about--content"]}>
                            <svg
                                width="346"
                                height="111"
                                viewBox="0 0 346 111"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className={[
                                    style["logo--about--eyebrow"],
                                    style["logo--about--eyebrow--x-concep"],
                                ].join(" ")}
                            >
                                <g clipPath="url(#clip0_132_12)">
                                    <path
                                        d="M128.36 54.95C128.36 47.72 134.32 43.04 140.96 43.04C145.35 43.04 148.72 45.19 150.92 48.41L145.31 51.92C144.43 50.55 142.58 49.72 141.01 49.72C137.69 49.72 135.74 52.11 135.74 54.94C135.74 57.77 137.69 60.31 141.01 60.31C142.57 60.31 144.43 59.48 145.31 58.11L150.92 61.62C148.72 64.84 145.35 66.99 140.96 66.99C134.32 66.99 128.36 62.16 128.36 54.93V54.95Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M153.6 55.05C153.6 47.82 159.46 43.04 165.95 43.04C172.44 43.04 178.35 47.82 178.35 55.05C178.35 62.28 172.44 67.01 165.95 67.01C159.46 67.01 153.6 62.23 153.6 55.05ZM170.98 55.05C170.98 51.93 168.73 49.73 165.95 49.73C163.17 49.73 160.92 51.93 160.92 55.05C160.92 58.17 163.17 60.32 165.95 60.32C168.73 60.32 170.98 58.17 170.98 55.05Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M205.83 54.1698V66.4198H198.6V54.6098C198.6 51.0998 196.45 49.7298 194.65 49.7298C192.7 49.7298 190.26 50.7598 190.26 54.5598V66.4198H183.03V43.6198H190.26V47.5698C191.14 44.4498 194.7 43.0298 196.8 43.0298C202.85 43.0298 205.83 47.1798 205.83 54.1598V54.1698Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M210.23 54.95C210.23 47.72 216.19 43.04 222.83 43.04C227.22 43.04 230.59 45.19 232.79 48.41L227.18 51.92C226.3 50.55 224.45 49.72 222.88 49.72C219.56 49.72 217.61 52.11 217.61 54.94C217.61 57.77 219.56 60.31 222.88 60.31C224.44 60.31 226.3 59.48 227.18 58.11L232.79 61.62C230.59 64.84 227.22 66.99 222.83 66.99C216.19 66.99 210.23 62.16 210.23 54.93V54.95Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M259.68 57.15H242.98C243.66 59.35 245.57 60.71 248.3 60.71C250.45 60.71 252.64 59.73 254.06 58.37L257.77 63.06C255.52 65.5 251.62 67.01 247.81 67.01C240.58 67.01 235.51 62.03 235.51 55.1C235.51 47.68 241.22 43.04 247.76 43.04C254.3 43.04 259.77 47.63 259.77 54.56C259.77 55.19 259.72 56.02 259.67 57.15H259.68ZM252.6 52.9C252.5 50.65 250.5 49.14 247.91 49.14C245.76 49.14 243.66 50.17 242.93 52.9H252.6Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M289.7 55C289.7 62.37 284.33 67.01 278.62 67.01C276.28 67.01 273.25 66.03 271.59 63.89V77.66H264.36V43.63H271.59V46.07C273.25 43.97 276.28 43.04 278.62 43.04C284.33 43.04 289.7 47.68 289.7 55ZM282.38 55C282.38 52.12 279.94 49.73 277.11 49.73C274.28 49.73 271.84 52.07 271.84 55C271.84 57.93 274.38 60.32 277.11 60.32C279.84 60.32 282.38 57.93 282.38 55Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M326.27 66.4198L323.73 58.6098H311.92L309.43 66.4198H301.23L313.68 32.7798H322.03L334.43 66.4198H326.28H326.27ZM314.01 51.9698H321.58L317.77 40.1098L314.01 51.9698Z"
                                        fill="white"
                                    />
                                    <path d="M337.84 66.4198V32.7798H345.5V66.4198H337.84Z" fill="white" />
                                    <path
                                        d="M95.2596 48.33H62.0596L94.6896 0H127.89L95.2596 48.33Z"
                                        fill="url(#paint0_linear_132_12)"
                                    />
                                    <path
                                        d="M51.4904 88.5602L36.7104 110.46H3.44043L34.8604 63.9302L51.4904 88.5602Z"
                                        fill="url(#paint1_linear_132_12)"
                                    />
                                    <path
                                        d="M74.19 97.3C74.13 97.3 74.06 97.3 74 97.3L12.96 6.9H37.8L59.76 39.43L63.88 33.33L41.37 0H0L4.66 6.9L68.24 101.07C67.84 101.92 67.62 102.87 67.62 103.87C67.62 107.5 70.56 110.44 74.19 110.44C77.82 110.44 80.76 107.5 80.76 103.87C80.76 100.24 77.82 97.3 74.19 97.3Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M127.83 103.56L101.38 64.3802C101.74 63.5702 101.94 62.6702 101.94 61.7302C101.94 58.1002 98.9997 55.1602 95.3697 55.1602C91.7397 55.1602 88.7997 58.1002 88.7997 61.7302C88.7997 65.3602 91.7397 68.3002 95.3697 68.3002C95.5097 68.3002 95.6497 68.3002 95.7896 68.2902L119.6 103.56H94.7597L62.1297 55.2302H53.8896L91.1796 110.46H132.49L127.83 103.56Z"
                                        fill="white"
                                    />
                                </g>
                                <defs>
                                    <linearGradient
                                        id="paint0_linear_132_12"
                                        x1="83.1596"
                                        y1="44.63"
                                        x2="109.28"
                                        y2="-0.609999"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop offset="0.15" stopColor="#05448E" />
                                        <stop offset="1" stopColor="#7FBFE9" />
                                    </linearGradient>
                                    <linearGradient
                                        id="paint1_linear_132_12"
                                        x1="22.9404"
                                        y1="107.35"
                                        x2="44.0304"
                                        y2="70.8302"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#7FBFE9" />
                                        <stop offset="0.85" stopColor="#05448E" />
                                    </linearGradient>
                                    <clipPath id="clip0_132_12">
                                        <rect width="345.5" height="110.46" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>

                            <p className={style["text--about--head"]}>
                                Text-to-3D 생성형 인공지능
                                <br />
                                누구나 디자이너가 되는 시대
                            </p>
                            <p className={style["text--about--copy"]}>
                                텍스트 한 줄로 시작해서 완성된 3D 설계 초기 개발비용을 90% 절감하는 차세대 AI
                            </p>
                            <a href="https://xconcepai.com/" target="_blank" className={style["button--about"]}>
                                Right now
                            </a>
                        </div>
                        <div className={style["unit--about--media"]}>
                            <img src={section1} />
                        </div>
                    </div>
                </div>
                <div
                    className={style["container--about"]}
                    style={{ background: "linear-gradient(135deg, #000 0%, #111 100%)" }}
                >
                    <div className={[style["wrapper--about"], style["reverse"]].join(" ")}>
                        <div className={style["unit--about--media"]}>
                            <img src={section2} />
                        </div>
                        <div className={style["unit--about--content"]}>
                            <svg
                                width="324"
                                height="93"
                                viewBox="0 0 324 93"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className={[style["logo--about--eyebrow"], style["logo--about--eyebrow--fajob"]].join(
                                    " "
                                )}
                            >
                                <g clipPath="url(#clip0_132_3)">
                                    <path
                                        d="M2.05733 72.9564C0.719068 72.7675 0 71.9423 0 70.5702V2.58499C0 1.80949 0.219715 1.19307 0.659146 0.735728C1.08859 0.288326 1.6179 0.0397691 2.22711 0H49.0264C49.8753 0 50.5345 0.248557 50.9739 0.74567C51.4034 1.23284 51.6231 1.87909 51.6231 2.67447V14.7046C51.6231 15.331 51.4034 15.9375 50.9639 16.4942C50.6443 16.9019 50.0451 17.3791 48.9765 17.3791H19.6046V31.7656H41.2066C41.9057 31.7656 42.5049 31.9644 42.9943 32.3521C43.5036 32.7598 43.7633 33.406 43.7633 34.2511V45.8836C43.7633 46.5099 43.5535 47.1065 43.1341 47.6732C42.6947 48.2697 42.0755 48.568 41.3164 48.568H19.6246V70.5106C19.6246 72.1113 18.7257 72.9464 17.0279 72.9464H2.05733V72.9564Z"
                                        fill="#05579E"
                                    />
                                    <path
                                        d="M104.015 75.4122C103.716 75.3426 103.486 75.094 103.226 74.7858C102.697 73.553 101.399 70.0533 100.5 67.6473L99.8808 65.9969C99.3215 64.5353 98.7722 63.0539 98.213 61.5825L98.1031 61.2842H72.6361L72.5263 61.5825C71.967 63.0639 71.4077 64.5353 70.8385 66.0068C70.1993 67.6473 69.5801 69.2877 68.9609 70.9382C68.4815 72.2903 67.5427 72.9664 66.1445 72.9664H51.7232C51.0241 72.9664 50.4349 72.7775 49.9655 72.3997C49.596 72.1014 49.2365 71.5446 49.6359 70.5405L76.1516 2.18737C76.2215 1.8891 76.3413 1.65048 76.5411 1.40193C76.7408 1.15337 76.9805 0.914756 77.2701 0.705969C77.5498 0.497181 77.8594 0.31822 78.1789 0.198913C78.5085 0.0696634 78.8281 0.0100098 79.1377 0.0100098H91.6515C92.2906 0.0100098 92.8399 0.208855 93.2993 0.606546C93.7088 0.964468 94.0184 1.27268 94.2281 1.561L94.2581 1.59083L95.4965 4.40449L119.975 59.077C120.085 59.3355 120.324 59.942 120.354 60.1508C120.464 60.807 120.075 61.1152 120.045 61.145L105.653 74.4776C105.523 74.6069 105.214 74.9151 104.914 75.1636C104.575 75.452 104.245 75.4917 104.015 75.4321V75.4122ZM84.9402 25.3628C84.5806 26.3769 84.2111 27.4407 83.8516 28.5344C83.2124 30.4433 82.5932 32.3721 81.974 34.3208C81.3548 36.2695 80.7256 38.1883 80.0865 40.0873C79.5871 41.5687 79.0878 43.0004 78.5984 44.3525L78.3787 44.959H92.4005L85.3896 24.1101L84.9502 25.3529L84.9402 25.3628Z"
                                        fill="#05579E"
                                    />
                                    <path
                                        d="M134.915 93C133.007 93 131.11 92.7813 129.262 92.3637C127.424 91.9362 125.647 91.2999 123.979 90.4647C122.311 89.6296 120.743 88.5757 119.315 87.3528C117.887 86.1299 116.608 84.6883 115.51 83.0776C115.32 82.7893 115.1 82.4214 114.99 82.1828C114.851 81.8746 114.791 81.3079 115.18 80.9201L125.117 71.6639C125.427 71.3557 125.677 71.0872 125.926 70.9182C126.156 70.7591 126.386 70.6995 126.575 70.6995C126.645 70.6995 126.875 70.7393 127.055 70.8188C127.255 70.9083 127.964 71.5645 128.183 71.7733L129.691 72.9961C130.211 73.4137 130.82 73.8015 131.509 74.1495C132.168 74.4776 132.987 74.6466 133.946 74.6466C134.655 74.6466 135.334 74.5074 136.013 74.229C136.692 73.9506 137.292 73.5827 137.791 73.1254C138.29 72.6681 138.7 72.1312 139.009 71.5048C139.309 70.8884 139.459 70.2322 139.459 69.5362V2.29666C139.459 0.924631 140.248 0.109365 141.686 0H156.097C158.025 0 159.083 1.02405 159.083 2.87332V69.5362C159.083 72.7774 158.424 75.8695 157.126 78.703C155.828 81.5366 154.06 84.042 151.863 86.1597C149.666 88.2675 147.079 89.9577 144.173 91.1706C141.266 92.3836 138.16 93 134.935 93H134.915Z"
                                        fill="#05579E"
                                    />
                                    <path
                                        d="M267.004 72.9564C266.265 72.9564 265.666 72.7575 265.206 72.3598C264.737 71.9522 264.497 71.3358 264.497 70.5205V2.58499C264.497 1.81944 264.717 1.19307 265.146 0.715843C265.586 0.238615 266.205 0 266.994 0H299.452C302.348 0 305.124 0.556767 307.701 1.66036C310.268 2.76395 312.555 4.28512 314.482 6.21392C316.41 8.13278 317.958 10.4096 319.076 12.9846C320.195 15.5597 320.764 18.3733 320.764 21.3262C320.764 23.7819 320.375 26.1084 319.596 28.236C318.907 30.1151 317.948 31.8451 316.749 33.3861L316.5 33.7043L316.789 33.9926C318.907 36.0507 320.624 38.4865 321.903 41.2306C323.281 44.2133 323.99 47.4246 323.99 50.7652C323.99 53.7579 323.401 56.6212 322.252 59.2957C321.104 61.9602 319.526 64.3364 317.568 66.3547C315.611 68.373 313.284 69.9936 310.667 71.1767C308.041 72.3598 305.234 72.9564 302.338 72.9564H267.004ZM284.122 57.8044H296.705C297.724 57.8044 298.683 57.5856 299.542 57.1581C300.411 56.7306 301.19 56.144 301.839 55.4083C302.488 54.6825 303.007 53.8473 303.367 52.9128C303.726 51.9881 303.906 51.0138 303.906 50.0196C303.906 49.0949 303.726 48.1504 303.367 47.2258C303.007 46.2912 302.498 45.4561 301.859 44.7303C301.219 44.0045 300.44 43.398 299.562 42.9407C298.683 42.4833 297.724 42.2546 296.715 42.2546H284.132V57.8143L284.122 57.8044ZM284.122 28.4647H294.119C295.187 28.4647 296.176 28.2957 297.065 27.9775C297.944 27.6594 298.703 27.1921 299.322 26.5956C299.941 25.999 300.43 25.2832 300.79 24.4679C301.15 23.6626 301.329 22.7479 301.329 21.7636C301.329 20.839 301.16 19.974 300.82 19.1786C300.48 18.3833 299.991 17.6674 299.372 17.051C298.753 16.4346 298.004 15.9474 297.135 15.5895C296.266 15.2316 295.307 15.0526 294.278 15.0526H284.142V28.4647H284.122Z"
                                        fill="#05579E"
                                    />
                                    <path
                                        d="M127.615 71.7335C127.645 71.1767 127.215 70.7293 126.566 70.6895C125.987 70.6597 125.518 71.1568 125.518 71.7335C125.518 72.3101 125.987 72.7774 126.566 72.7774C127.145 72.7774 127.585 72.3101 127.615 71.7335Z"
                                        fill="#05579E"
                                    />
                                    <path
                                        d="M115.91 82.7097C116.489 82.7097 116.959 82.2423 116.959 81.6658C116.959 81.0892 116.489 80.6218 115.91 80.6218C115.331 80.6218 114.861 81.0892 114.861 81.6658C114.861 82.2423 115.331 82.7097 115.91 82.7097Z"
                                        fill="#05579E"
                                    />
                                    <path
                                        d="M211.296 1.19312C188.345 1.19312 169.729 19.7156 169.729 42.5728C169.729 56.2534 176.411 68.3532 186.688 75.8894C186.098 71.6043 182.842 68.5421 181.374 62.3082C179.077 52.5847 181.075 37.2537 193.279 33.3265C192.55 35.5536 192.38 37.1742 192.38 39.6399C192.38 52.2268 202.627 62.4375 215.28 62.4375C220.224 62.4375 224.798 60.8766 228.543 58.222C233.167 62.3878 235.424 68.5719 235.424 75.611C235.424 75.8397 235.414 76.0584 235.404 76.2771C245.961 68.7707 252.852 56.4821 252.852 42.5828C252.852 19.7355 234.246 1.20306 211.286 1.20306L211.296 1.19312ZM215.49 55.4381C205.973 55.4381 198.173 48.1803 197.334 38.9141C197.334 38.9141 197.354 38.9141 197.364 38.924L207.231 41.4792C209.238 41.9962 211.286 40.8031 211.815 38.8047C212.334 36.8063 211.136 34.7682 209.128 34.2412C209.128 34.2412 198.542 31.5668 198.183 31.5767C200.58 24.3487 207.421 19.119 215.49 19.119C225.557 19.119 233.727 27.2419 233.727 37.2736C233.727 47.3054 225.567 55.4282 215.49 55.4282V55.4381Z"
                                        fill="url(#paint0_linear_132_3)"
                                    />
                                </g>
                                <defs>
                                    <linearGradient
                                        id="paint0_linear_132_3"
                                        x1="211.296"
                                        y1="0.934616"
                                        x2="211.296"
                                        y2="75.7601"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#00AC94" />
                                        <stop offset="0.9" stopColor="#005BAA" />
                                    </linearGradient>
                                    <clipPath id="clip0_132_3">
                                        <rect width="324" height="93" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>

                            <p className={style["text--about--head"]}>
                                매칭부터 급여 정산까지
                                <br />
                                현장에서 시작된 진짜 솔루션
                            </p>
                            <p className={style["text--about--copy"]}>
                                단순 매칭이 아닌 프로젝트 전 과정을 관리하는 통합 All-in-One 솔루션. 검증된 전문
                                엔지니어 매칭, 스마트 업무일지, 자동 급여산출, 자동 경력관리, 이력서 생성, 신뢰도 레벨
                                시스템, 블랙리스트
                            </p>
                            <a href="https://www.fa-job.com/" target="_blank" className={style["button--about"]}>
                                Right now
                            </a>
                        </div>
                    </div>
                </div>
                <Portfolio />
                <History />
                <div className={style["container--inbound"]}>
                    <div className={style["unit--content"]}>
                        <Inbound />
                    </div>
                </div>
                <Xconcep />
                <Footer />
            </div>
            <ImagePopupGroup popups={displayPopups} />
            {createPortal(
                <CSSTransition in={openInbound} timeout={400} classNames="popup-fade" unmountOnExit nodeRef={inbound}>
                    <div
                        className={popup["div--popup"]}
                        ref={inbound}
                        onClick={(e) => {
                            if (document.querySelector(".container-sheet")?.contains(e.target as Node)) return;
                            setOpenInbound(false);
                        }}
                    >
                        <div className={`${popup["container--popup"]} container-sheet`}>
                            <button className={popup["button--popup"]} onClick={() => setOpenInbound(false)}>
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="#D6D6D6"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M16 7.51H10.25V1.75C10.25 1.35218 10.092 0.970644 9.81066 0.68934C9.52936 0.408035 9.14782 0.25 8.75 0.25C8.35218 0.25 7.97064 0.408035 7.68934 0.68934C7.40804 0.970644 7.25 1.35218 7.25 1.75V7.5H1.5C1.10218 7.5 0.720644 7.65804 0.43934 7.93934C0.158035 8.22064 0 8.60218 0 9C0 9.39782 0.158035 9.77936 0.43934 10.0607C0.720644 10.342 1.10218 10.5 1.5 10.5H7.25V16.25C7.25 16.6478 7.40804 17.0294 7.68934 17.3107C7.97064 17.592 8.35218 17.75 8.75 17.75C9.14782 17.75 9.52936 17.592 9.81066 17.3107C10.092 17.0294 10.25 16.6478 10.25 16.25V10.5H16C16.3978 10.5 16.7794 10.342 17.0607 10.0607C17.342 9.77936 17.5 9.39782 17.5 9C17.5 8.60218 17.342 8.22064 17.0607 7.93934C16.7794 7.65804 16.3978 7.5 16 7.5V7.51Z" />
                                </svg>
                            </button>
                            <div className={popup["wrapper--popup--inbound"]}>
                                <Inbound />
                            </div>
                        </div>
                    </div>
                </CSSTransition>,
                document.body
            )}
        </>
    );
};

const Slidshow = () => {
    const images = [main1, main2, main3, main4, main5, main6, main7, main8, main9, main10];
    const totalImages = [...images, images[0]]; // 마지막에 첫 이미지 복제

    const [index, setIndex] = useState(0);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const interval = setInterval(() => {
            if (index == 0) {
                containerRef.current!.style.transition = "";
            }
            setIndex((prev) => prev + 1);
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (index === images.length) {
            // transition 끄고 index 0으로 점프
            const timeout = setTimeout(() => {
                containerRef.current!.style.transition = "none";
                setIndex(0);
            }, 800);
            return () => clearTimeout(timeout);
        }
    }, [index]);

    return (
        <div className={style["unit--front--background"]}>
            <div
                className={style["unit--front--background--slider"]}
                ref={containerRef}
                style={{
                    transform: `translateX(-${index * 100}vw)`,
                    display: "flex",
                }}
            >
                {totalImages.map((img, i) => (
                    <div
                        key={i}
                        className={style["unit--front--background--slide"]}
                        style={{
                            backgroundImage: `url(${img})`,
                            width: `${100 / totalImages.length}%`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

const Partners = () => {
    const logos = [
        logo1,
        logo2,
        logo3,
        logo4,
        logo5,
        logo6,
        logo7,
        logo8,
        logo9,
        logo10,
        logo11,
        logo12,
        logo13,
        logo14,
        logo15,
        logo16,
        logo17,
        logo18,
    ];

    return (
        <div className={style["container--partners"]}>
            <div className={style["unit--slider"]}>
                <div className={style["unit--slider-track"]}>
                    {[...logos, ...logos].map((logo, index) => (
                        <img key={index} src={logo} alt={`partner-${index}`} />
                    ))}
                </div>
            </div>
        </div>
    );
};

const Portfolio = () => {
    const [detail, setDetail] = useState<boolean>(false);
    const [show, setShow] = useState<number>(0);
    const container = useRef<HTMLDivElement>(null);

    useEffect(() => {
        console.log(show);
        if (show !== 0) {
            console.log("heelo");
            setDetail(true);
        }
    }, [show]);
    useEffect(() => {
        document.body.style.overflow = detail ? "hidden" : "auto";
    }, [detail]);

    return (
        <>
            <div className={style["container--portfolio"]}>
                <div className={style["unit--content"]}>
                    <h4 className={style["text--content"]}>R&D STORY</h4>
                    <div className={style["container--portfolio-lists"]}>
                        <PortfolioList
                            text="자동차 촬영 전문 버추얼스튜디오 디스플레이 거치대 솔루션"
                            bg={bg1}
                            onClick={() => {
                                setShow(1);
                                setDetail(true);
                            }}
                        />
                        <PortfolioList
                            text="TV 패널 합착 공정의 생산성과 품질을 동시에 잡는 고정밀 자동화 솔루션"
                            bg={bg2}
                            onClick={() => {
                                setShow(2);
                                setDetail(true);
                            }}
                        />
                        <PortfolioList
                            text="식물성 대체 계란 생산의 표준을 제시하는 모듈형 로봇 자동화 생산 시스템"
                            bg={bg3}
                            onClick={() => {
                                setShow(3);
                                setDetail(true);
                            }}
                        />
                        <PortfolioList
                            text="주파수 기반 미세 부품 분리 기술과 로봇 정열 시스템으로 정밀 조립 품질을 확보하는 자동화 솔루션"
                            bg={bg4}
                            onClick={() => {
                                setShow(4);
                                setDetail(true);
                            }}
                        />
                        <PortfolioList
                            text="생산 효율성과 품질 일관성을 동시에 실현한 One-Line 자동화 패키징 솔루션"
                            bg={bg5}
                            onClick={() => {
                                setShow(5);
                                setDetail(true);
                            }}
                        />
                        <PortfolioList
                            text="정밀·안정·효율을 갖춘 FOAM 이동 자동화 솔루션"
                            bg={bg6}
                            onClick={() => {
                                setShow(6);
                                setDetail(true);
                            }}
                        />
                    </div>
                </div>
            </div>

            {createPortal(
                <CSSTransition in={detail} timeout={400} classNames="popup-fade" unmountOnExit nodeRef={container}>
                    <div
                        className={popup["div--popup"]}
                        ref={container}
                        onClick={(e) => {
                            if (document.querySelector(".container-sheet")?.contains(e.target as Node)) return;
                            setDetail(false);
                        }}
                    >
                        <div className={`${popup["container--popup"]} container-sheet`}>
                            <button className={popup["button--popup"]} onClick={() => setDetail(false)}>
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="#D6D6D6"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M16 7.51H10.25V1.75C10.25 1.35218 10.092 0.970644 9.81066 0.68934C9.52936 0.408035 9.14782 0.25 8.75 0.25C8.35218 0.25 7.97064 0.408035 7.68934 0.68934C7.40804 0.970644 7.25 1.35218 7.25 1.75V7.5H1.5C1.10218 7.5 0.720644 7.65804 0.43934 7.93934C0.158035 8.22064 0 8.60218 0 9C0 9.39782 0.158035 9.77936 0.43934 10.0607C0.720644 10.342 1.10218 10.5 1.5 10.5H7.25V16.25C7.25 16.6478 7.40804 17.0294 7.68934 17.3107C7.97064 17.592 8.35218 17.75 8.75 17.75C9.14782 17.75 9.52936 17.592 9.81066 17.3107C10.092 17.0294 10.25 16.6478 10.25 16.25V10.5H16C16.3978 10.5 16.7794 10.342 17.0607 10.0607C17.342 9.77936 17.5 9.39782 17.5 9C17.5 8.60218 17.342 8.22064 17.0607 7.93934C16.7794 7.65804 16.3978 7.5 16 7.5V7.51Z" />
                                </svg>
                            </button>
                            <div className={style["unit--portfolio-detail--background"]}>
                                <img
                                    src={
                                        show === 1
                                            ? bg1
                                            : show === 2
                                                ? bg2
                                                : show === 3
                                                    ? bg3
                                                    : show === 4
                                                        ? bg4
                                                        : show === 5
                                                            ? bg5
                                                            : bg6
                                    }
                                />
                            </div>
                            <div className={style["unit--portfolio-detail--head"]}>
                                {/* 1 */}
                                {show === 1 && (
                                    <>
                                        <h4 className={style["text--portfolio-detail--head"]}>
                                            이동식 디스플레이 패널 거치대
                                            <span>자동차 촬영 전문 버추얼스튜디오 디스플레이 거치대 솔루션</span>
                                        </h4>
                                    </>
                                )}
                                {/* 2 */}
                                {show === 2 && (
                                    <>
                                        <h4 className={style["text--portfolio-detail--head"]}>
                                            OBMS 압착기
                                            <span>
                                                TV 패널 합착 공정의 생산성과 품질을 동시에 잡는 고정밀 자동화 솔루션
                                            </span>
                                        </h4>
                                    </>
                                )}
                                {/* 3 */}
                                {show === 3 && (
                                    <>
                                        <h4 className={style["text--portfolio-detail--head"]}>
                                            6구 멀티 주액 성형 장비
                                            <span>
                                                식물성 대체 계란 생산의 표준을 제시하는 모듈형 로봇 자동화 생산 시스템
                                            </span>
                                        </h4>
                                    </>
                                )}
                                {/* 4 */}
                                {show === 4 && (
                                    <>
                                        <h4 className={style["text--portfolio-detail--head"]}>
                                            미세부품 정렬기
                                            <span>
                                                주파수 기반 미세 부품 분리 기술과 로봇 정열 시스템으로 정밀 조립 품질을
                                                확보하는 자동화 솔루션
                                            </span>
                                        </h4>
                                    </>
                                )}
                                {/* 5 */}
                                {show === 5 && (
                                    <>
                                        <h4 className={style["text--portfolio-detail--head"]}>
                                            캡핑기 라인
                                            <span>
                                                생산 효율성과 품질 일관성을 동시에 실현한 One-Line 자동화 패키징 솔루션
                                            </span>
                                        </h4>
                                    </>
                                )}
                                {/* 6 */}
                                {show === 6 && (
                                    <>
                                        <h4 className={style["text--portfolio-detail--head"]}>
                                            FOAM 이재기
                                            <span>정밀·안정·효율을 갖춘 FOAM 이동 자동화 솔루션</span>
                                        </h4>
                                    </>
                                )}
                            </div>
                            <div className={style["unit--portfolio-detail--content"]}>
                                {/* 1 */}
                                {show === 1 && (
                                    <>
                                        <p>
                                            한 콘텐츠 제작 고객사는 자동차 씬을 전문적으로 촬영할 수 있는 스튜디오를
                                            구축하고자 했습니다.
                                            <br />
                                            당시 시장에 나와 있는 기존 시스템은 벽면 고정 방식의 스크린 장비로, 유연한
                                            연출이나 앵글 변화에 한계가 있어 고객이 원하는 연출에도 제한이 있었습니다.
                                        </p>
                                        <p>
                                            고객은 제한 없는 연출을 위해, 업다운 조절이 가능하고 스크린 각도를 자유롭게
                                            조절할 수 있는 새로운 장비를 원했습니다.
                                        </p>
                                        <p>
                                            이를 위해선, 고해상도 LED 디스플레이가 흔들림 없이 고정될 수 있는 장비가
                                            필요했습니다.
                                        </p>
                                        <p>
                                            최초 시도는 기존 장비에 거치대를 추가하는 방식이었으나, 구조적 한계와 진동
                                            이슈로 인해 안정성이 확보되지 못했고 결국 실패로 끝나게 되었습니다.
                                        </p>
                                        <p>
                                            이 과정에서 고객사는 디엔지니어에게 기존 장비를 개조하거나, 새로운 솔루션을
                                            제안해 달라는 요청을 하였습니다.
                                        </p>
                                        <blockquote>
                                            디엔지니어는 현장 분석과 구조 해석을 통해 기존 장비의 강성이 목적에 비해
                                            부족하다는 결론을 도출하고, 보강 방식은 비효율적이고 비용도 높다는 판단 하에
                                            전면 재설계를 결정하였습니다.
                                        </blockquote>
                                        <p>이후 고객의 니즈를 반영해 아래와 같은 기술적 과제를 해결함</p>
                                        <ul>
                                            <li>업다운 가능 구조로 공간 활용과 다양한 촬영 각도 확보</li>
                                            <li>스크린 각도 조절 기능을 통해 연출 유연성 확보</li>
                                            <li>
                                                진동 최소화 설계로 고해상도 LED 디스플레이의 이탈 및 손상 방지 모듈화 및
                                                유지보수 용이성 확보를 위한 구조 설계
                                            </li>
                                        </ul>
                                        <p>
                                            그 결과, 고객사의 촬영 환경은 이전보다 더 정교하고 유연하게 개선되었으며,
                                            디엔지니어는 기술적 신뢰성과 문제 해결 역량을 동시에 인정받는 계기가 되었음.
                                        </p>
                                    </>
                                )}
                                {/* 2 */}
                                {show === 2 && (
                                    <>
                                        <p>
                                            TV는 액정 디스플레이 패널과 후면 백커버를 정밀하게 맞춰 합착하는 공정을 통해
                                            완성됩니다.
                                            <br />이 과정에서 압착기의 정밀도와 안정성은 제품 품질에 직접적인 영향을
                                            미치게 되지요.
                                        </p>
                                        <p>
                                            고객사는 생산 중인 TV의 크기가 다양해지는 상황에서, 기존 압착기는 31인치
                                            이하의 소형 TV 패널까지 커버하지 못하는 한계를 안고 있었습니다. 기존 장비
                                            도면과의 간섭, 라인 재구성의 부담 등 여러 제약 또한 존재했습니다.
                                        </p>
                                        <p>
                                            디엔지니어는 이러한 문제를 해결하기 위해 다음과 같은 과정을 거쳐 프로젝트를
                                            수행하였습니다
                                        </p>
                                        <ol>
                                            <li>
                                                기존 생산라인 구조 및 도면 분석
                                                <ul>
                                                    <li>기존 장비들과의 간섭 최소화를 위해 도면을 면밀히 검토</li>
                                                    <li>
                                                        가용 설치 공간을 정밀 측정하여, 별도 공간 확장 없이도 설치
                                                        가능한 최적 구조 설계
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                압착 공정의 정밀성과 유연성 확보
                                                <ul>
                                                    <li>
                                                        최소 31인치까지 다양한 크기의 디스플레이 패널을 안정적으로
                                                        압착할 수 있는 구조 설계
                                                    </li>
                                                    <li>
                                                        압력 분산 시스템과 수직 평형 구조를 통해 화면 파손이나 휨 없이
                                                        정밀한 합착 가능
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                진동과 충격 제어를 위한 구조 보강
                                                <ul>
                                                    <li>
                                                        LED 디스플레이 특성상 진동에 매우 민감하므로, 진동 흡수 설계
                                                        적용
                                                    </li>
                                                    <li>
                                                        프레임 내부에 감쇠 소재와 완충 구조를 삽입하여 패널 이탈 및 손상
                                                        방지
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                모듈화 설계 및 현장 최적화 조립 방식 채택
                                                <ul>
                                                    <li>각 구성부를 모듈화하여 현장 상황에 맞게 신속 조립 가능</li>
                                                    <li>장비 유지보수와 향후 업그레이드를 고려한 확장성 확보</li>
                                                </ul>
                                            </li>
                                        </ol>
                                        <blockquote>
                                            해당 장비는 현재 LG디스플레이 평택공장에 성공적으로 설치되어 운영 중이며,
                                            기존 설비의 한계를 기술적으로 극복하고 고객 요구에 정확히 대응한 대표적인
                                            맞춤형 설비 개발 사례로 인정받고 있습니다.
                                        </blockquote>
                                        <p>
                                            디엔지니어는 단순한 장비 제작이 아닌,
                                            <br />
                                            <b>
                                                “고객의 공정 문제를 파악하고, 구조적·기술적 해법을 도출해 구현하는 전문
                                                엔지니어 그룹”
                                            </b>
                                            입니다.
                                        </p>
                                        <p>
                                            이 사례처럼, 현장의 문제를 함께 고민하고 해결하는 파트너로서 고객사의 신뢰를
                                            바탕으로 함께 성장하고자 노력하고 있습니다.
                                        </p>
                                    </>
                                )}
                                {/* 3 */}
                                {show === 3 && (
                                    <>
                                        <p>
                                            식물성 단백질 기반 식품 시장이 확대됨에 따라, 기존에 없던 완전히 새로운
                                            형태의 제품 생산이 요구되고 있습니다.
                                        </p>
                                        <p>
                                            이번 프로젝트의 고객사인 메타텍스쳐라는 푸드테크 스타트업은{" "}
                                            <b>콩을 기반으로 한 ‘식물성 계란’</b>을 개발해 흰자와 노른자가 분리된 형태로
                                            제품화를 진행하고 있었습니다.
                                        </p>
                                        <p>
                                            그러나 소비자에게 익숙한 ‘삶은 계란 형태’로 성형된 제품은 아직 국내 시장에
                                            존재하지 않았고, 이에 따라 “완전한 원형의 대란 사이즈 식물성 계란”을 성형할
                                            수 있는 자동화 장비도 존재하지 않았습니다.
                                        </p>
                                        <blockquote>
                                            고객사는 기존에 존재하지 않던 새로운 형태의 솔루션의 제작을 디엔지니어에게
                                            요청하게 되었습니다.
                                        </blockquote>
                                        <hr />
                                        <p>개발 목표</p>
                                        <ul>
                                            <li>국내 최초로 원형 식물성 계란을 자동으로 성형하는 설비 개발</li>
                                            <li>흰자/노른자를 분리 주입하고, 고르게 성형 가능한 공정 구현</li>
                                            <li>몰드 30개를 1사이클로 처리할 수 있는 고효율 설계</li>
                                            <li>고온, 고점도의 식품 성형 특성 고려한 정밀 이송·투입 공정 구현</li>
                                            <li>중량급 몰드 자동 이송을 위한 로딩/언로딩 장치 포함</li>
                                        </ul>
                                        <hr />
                                        <p>기술적 핵심 요소</p>
                                        <ol>
                                            <li>
                                                <b>이중 주액 시스템 설계</b>
                                                <ul>
                                                    <li>흰자와 노른자를 분리하여 순차적으로 몰드에 정량 주입</li>
                                                    <li>각각 점도와 응고 온도가 달라 정밀 타이밍 제어 필요</li>
                                                    <li>전용 밸브 및 센서 기반 제어기술 적용</li>
                                                </ul>
                                            </li>
                                            <li>
                                                <b>몰드 다관절 이송 구조</b>
                                                <ul>
                                                    <li>30개 대란 사이즈 몰드판을 동시에 가열 성형할 수 있도록 설계</li>
                                                    <li>무게를 고려해 대차 구조를 채택, 인체공학적 로딩 가능</li>
                                                    <li>몰드는 스카라 로봇에 의해 자동 이송, 고정밀 위치 제어 가능</li>
                                                </ul>
                                            </li>
                                            <li>
                                                <b>스카라 로봇 + 인덱스 테이블 연동 제어</b>
                                                <ul>
                                                    <li>고정된 공정 순서를 유지하기 위해 인덱스 테이블을 사용</li>
                                                    <li>
                                                        각 공정 스테이션(주입, 성형, 냉각, 언로딩)을 정밀하게 분할 제어
                                                    </li>
                                                    <li>로봇과 테이블의 연동으로 노동력 최소화, 일관성 극대화</li>
                                                </ul>
                                            </li>
                                            <li>
                                                <b>고온 성형 구조와 위생 설계</b>
                                                <ul>
                                                    <li>1차 고온 성형 후, 제품이 깨지지 않도록 구조적 보완</li>
                                                    <li>
                                                        식품 장비 기준에 따라 위생 재질 적용 (SUS304, 테프론 코팅 등)
                                                    </li>
                                                </ul>
                                            </li>
                                        </ol>
                                        <hr />
                                        <p>프로젝트 결과 및 의의</p>
                                        <ol>
                                            <li>국내 최초 식물성 계란 성형기로 특허 출원 완료</li>
                                            <li>시제품 기반 양산 장비로 확장 가능성 확보</li>
                                            <li>메타텍스쳐의 차세대 푸드테크 라인 구축에 기여</li>
                                            <li>고온·고점도·복합 성분 기반 자동화 공정 기술 확보</li>
                                        </ol>
                                        <hr />
                                        <h1>기술로 문제를 해결하다</h1>
                                        <blockquote>
                                            디엔지니어는 단순한 장비 제작이 아닌,
                                            <b>"아이디어를 제품으로 실현하고, 시장의 빈틈을 메우는 솔루션을 설계"</b>를
                                            합니다.
                                        </blockquote>
                                        <p>
                                            이번 메타텍스쳐와의 협업은 기존에 존재하지 않던 제품을 위한 전례 없는 자동화
                                            공정을 설계·실현한 사례로, 푸드테크 산업 내에서도 높은 기술성과 혁신성을
                                            입증한 개발 프로젝트입니다.
                                        </p>
                                    </>
                                )}
                                {/* 4 */}
                                {show === 4 && (
                                    <>
                                        <h1>적용 배경 및 문제점</h1>
                                        <p>현장 문제:</p>
                                        <p>
                                            마스카라 솔은 자동 생산되지만, 생산 직후 여러 개가 엉켜서 뭉쳐 있는 상태로
                                            배출됩니다.
                                        </p>
                                        <p>
                                            따라서, 작업자가 솔을 수작업으로 하나씩 떼어내어 손잡이 연결 공정에 투입하며
                                            <br />→ 이로 인해 작업 효율 저하, 인건비 부담 증가, 생산 병목 발생하게
                                            됩니다.
                                        </p>
                                        <h1>개선 솔루션 개요</h1>
                                        <ul>
                                            <li>진동 피더 시스템을 통해 솔을 개별 분리</li>
                                            <li>비전 시스템으로 솔의 위치 및 방향을 인식</li>
                                            <li>
                                                다관절 로봇 4대를 활용하여 개별 솔을 정확히 픽업 및 정렬 후 후공정에
                                                자동 공급
                                            </li>
                                        </ul>
                                        <h1>성과 및 장점</h1>
                                        <ul>
                                            <li>효율 향상: 기존 수작업 대비 로봇 1대 기준 2.9배 작업 효율 증가</li>
                                            <li>
                                                고정밀 자동화: 진동 피더 + 비전 + 로봇을 결합한 정밀한 정렬 시스템 구현
                                            </li>
                                            <li>인건비 절감: 수작업 제거로 인건비 부담 감소 및 작업자 피로도 최소화</li>
                                            <li>공정 품질 안정화: 정렬 정확도 향상으로 후공정 불량률 감소</li>
                                        </ul>
                                        <h1>기술적 차별화 요소</h1>
                                        <ul>
                                            <li>
                                                주파수 조절형 진동 분리 기술: 다양한 형상/재질의 부품도 효과적으로 분리
                                                가능
                                            </li>
                                            <li>4대 로봇의 병렬 동작 제어: 고속 정렬 및 배치 성능 확보</li>
                                            <li>
                                                정밀 비전 인식 기반 방향 제어: 비정형 부품의 방향성을 고려한 로봇 동작
                                                설계
                                            </li>
                                        </ul>
                                    </>
                                )}
                                {/* 5 */}
                                {show === 5 && (
                                    <>
                                        <h1>자동 캡핑기 라인 개요</h1>
                                        <p>설비 목적:</p>
                                        <p>
                                            충진된 PET 병에 병뚜껑(캡)을 자동으로 체결하고, 라벨 부착 및 날짜 마킹까지
                                            일괄 처리하는 자동화 설비
                                        </p>
                                        <p>주요 기능 및 특징:</p>
                                        <ul>
                                            <li>병의 자동 정렬 및 고정 (클램프)</li>
                                            <li>병뚜껑 자동 체결 (캡핑 모듈)</li>
                                            <li>스티커형 라벨 자동 부착 (라벨링 시스템)</li>
                                            <li>유통기한 및 제조일자 등 인쇄 (잉크젯 마킹기)</li>
                                            <li>컨베이어 기반 자동 이송</li>
                                        </ul>
                                        <hr />
                                        <h1>고추가루 수출용 자동화 적용 사례</h1>
                                        <p>기존 방식:</p>
                                        <p>
                                            사람 손으로 뚜껑 체결 → 라벨 스티커 부착 → 날짜 수기 또는 수동 마킹 → 반복
                                            작업으로 손목 피로 및 생산성 저하
                                        </p>
                                        <p>자동화 전환 이후 변화:</p>
                                        <ul>
                                            <li>정량 충진기 연동 → 고추가루 자동 투입</li>
                                            <li>캡핑 자동화 → 뚜껑 체결 시간 단축 및 균일한 품질 확보</li>
                                            <li>라벨 자동 부착 → 외관 품질 향상 및 불량률 감소</li>
                                            <li>잉크젯 마킹기 적용 → 정확한 유통기한 마킹 가능</li>
                                            <li>생산성 증가 → 시간당 처리량 극대화 (기존 대비 3~5배 이상)</li>
                                        </ul>
                                        <hr />
                                        <h1>기술적 개선 포인트 제안</h1>
                                        <ol>
                                            <li>
                                                충진기와 캡핑기 연동 제어 시스템을 통해 병 충진과 캡핑 타이밍 정확히
                                                맞춤
                                            </li>
                                            <li>병 종류 변경 시 툴 교체 최소화를 위한 모듈형 설계</li>
                                            <li>원격 모니터링 기능 추가 가능성 검토 (생산량, 불량률 실시간 확인)</li>
                                            <li>라벨 인쇄기 연동 기능을 넣어 라벨 내용 자동 변경 가능하도록 개선</li>
                                        </ol>
                                    </>
                                )}
                                {/* 6 */}
                                {show === 6 && (
                                    <>
                                        <h1>프로젝트 개요</h1>
                                        <ul>
                                            <li>프로젝트명: LNG 선박 보온용 FOAM 생산용 적층 이동 이재기 개발</li>
                                            <li>의뢰처: LNG 선박용 단열 FOAM 제조 기업</li>
                                            <li>
                                                요구사항: 약 100kg 중량의 FOAM 단열재를 안정적이고 반복적으로 적재 및
                                                이송할 수 있는 구조
                                            </li>
                                        </ul>
                                        <h1>기존 장비의 문제점</h1>
                                        <ul>
                                            <li>기계적 불안정성: 업다운 또는 횡이송 중 기계 충격 및 진동 발생</li>
                                            <li>구조적 취약성: 하중 지지 및 반복 동작에서 장비의 내구성 저하</li>
                                            <li>생산 효율 저하: 공정 중 장비 문제로 인한 중단 또는 수작업 보완 발생</li>
                                        </ul>
                                        <h1>설계 시 고려사항</h1>
                                        <ol>
                                            <li>
                                                하중 분산 및 안정성 확보
                                                <ul>
                                                    <li>
                                                        FOAM의 형상과 밀도 분석을 바탕으로 지지 프레임 및 흡착 구조
                                                        최적화
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                반복 정밀 동작 가능 설계
                                                <ul>
                                                    <li>리프팅 실린더 및 고정 가이드 구조로 정밀 업다운 구현</li>
                                                </ul>
                                            </li>
                                            <li>
                                                다양한 형상 대응성
                                                <ul>
                                                    <li>FOAM 규격에 따라 유동적으로 대처 가능한 모듈형 그리퍼 설계</li>
                                                </ul>
                                            </li>
                                            <li>
                                                작업자 접근 및 유지보수 용이성 고려
                                                <ul>
                                                    <li>상부 데크 및 난간 구조 포함하여 현장 운용 안전성 강화</li>
                                                </ul>
                                            </li>
                                        </ol>
                                        <h1>기술적 핵심 요소</h1>
                                        <ul>
                                            <li>전동 서보 기반 리프팅 시스템 → 충격 없이 정확한 상승/하강 제어</li>
                                            <li>진공 흡착 또는 메커니컬 그리퍼 → FOAM의 표면 특성과 이형성 고려</li>
                                            <li>고강성 프레임 설계 → 진동 및 중량에 대응 가능한 구조 강도 확보</li>
                                            <li>모듈화 플랫폼 → 설치 환경 변화나 규격 변경에도 빠른 대응 가능</li>
                                        </ul>
                                        <h1>예상 효과</h1>
                                        <ul>
                                            <li>장비 고장률 감소 및 생산 효율 향상</li>
                                            <li>작업 안정성 및 정밀도 개선</li>
                                            <li>기존 수작업 또는 불완전한 자동화 공정 완전 대체</li>
                                            <li>FOAM 단열재의 품질 확보 및 납기 신뢰도 향상</li>
                                        </ul>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </CSSTransition>,
                document.body
            )}
        </>
    );
};
const PortfolioList = ({ text, bg, onClick }: { text: string; bg: string; onClick: () => void }) => {
    return (
        <div className={style["unit--portfolio-list"]} onClick={onClick}>
            <div className={style["unit--portfolio-list--cover"]} style={{ backgroundImage: `url(${bg})` }}>
                <button className={style["button--portfolio-list"]}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="#D6D6D6" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 7.51H10.25V1.75C10.25 1.35218 10.092 0.970644 9.81066 0.68934C9.52936 0.408035 9.14782 0.25 8.75 0.25C8.35218 0.25 7.97064 0.408035 7.68934 0.68934C7.40804 0.970644 7.25 1.35218 7.25 1.75V7.5H1.5C1.10218 7.5 0.720644 7.65804 0.43934 7.93934C0.158035 8.22064 0 8.60218 0 9C0 9.39782 0.158035 9.77936 0.43934 10.0607C0.720644 10.342 1.10218 10.5 1.5 10.5H7.25V16.25C7.25 16.6478 7.40804 17.0294 7.68934 17.3107C7.97064 17.592 8.35218 17.75 8.75 17.75C9.14782 17.75 9.52936 17.592 9.81066 17.3107C10.092 17.0294 10.25 16.6478 10.25 16.25V10.5H16C16.3978 10.5 16.7794 10.342 17.0607 10.0607C17.342 9.77936 17.5 9.39782 17.5 9C17.5 8.60218 17.342 8.22064 17.0607 7.93934C16.7794 7.65804 16.3978 7.5 16 7.5V7.51Z" />
                    </svg>
                </button>
            </div>
            <div className={style["unit--portfolio-list--content"]}>
                <p className={style["text--portfolio-list"]}>{text}</p>
            </div>
        </div>
    );
};
const History = () => {
    let [open, setOpen] = useState<boolean>(false);
    let container = useRef<HTMLDivElement>(null);
    let content = useRef<HTMLDivElement>(null);
    const [historyConfig, setHistoryConfig] = useState<HistoryConfig>(FALLBACK_HISTORY_CONFIG);
    const [isHistoryLoading, setIsHistoryLoading] = useState<boolean>(true);

    useEffect(() => {
        let active = true;

        fetchHistoryConfig()
            .then((nextConfig) => {
                if (!active) return;
                setHistoryConfig(nextConfig);
            })
            .finally(() => {
                if (!active) return;
                setIsHistoryLoading(false);
            });

        return () => {
            active = false;
        };
    }, []);

    // useEffect(() => {
    //     const height = content.current?.offsetHeight;

    //     if (open) {
    //         container.current!.style.height = height + "px";
    //         setTimeout(() => {
    //             container.current!.style.height = "auto";
    //         }, 400);
    //     } else {
    //         container.current!.style.height = height + "px";
    //         setTimeout(() => {
    //             container.current!.style.height = "408px";
    //         }, 0);
    //     }
    // }, [open]);

    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "auto";
    }, [open]);

    const popupHistoryItems = (historyConfig.items.length > 0 ? historyConfig.items : FALLBACK_HISTORY_CONFIG.items).filter(
        (item) => item.contents.length > 0
    );

    return (
        <>
            <div className={style["container--history"]}>
                <div className={style["unit--content"]}>
                    <h4 className={style["text--content"]}>
                        현장에서 입증된
                        <br />
                        디엔지니어의 압도적 전문성
                    </h4>
                    <p className={style["text--content--copy"]}>
                        FA 시스템 분야에서 축적된 경험과 기술력을 바탕으로 고객의 요구사항에 최적화된 솔루션을
                        제공합니다.
                    </p>
                    {/* <div ref={container} className={[style["unit--history"], open ? style["open"] : ""].join(" ")}> */}
                    <div ref={container} className={style["unit--history"]}>
                        <div ref={content}>
                            <HistoryList
                                year="2020.07"
                                contents={[
                                    "The Engineer 설립",
                                    "The Engineer 상표 출원 (2021.03.24 기준 심사 중)",
                                    "스마트제조혁신추진단 공급기업 등록",
                                ]}
                            />
                            <HistoryList year="2020.09" contents={["매출 2.6억 돌파", "기업 흑자 전환(부채 없음)"]} />
                            <HistoryList
                                year="2020.12"
                                contents={[
                                    "카카오톡 오픈채팅방 개설",
                                    "엔지니어 구인구직 네트워크",
                                    "인원 1200명 이상 유지 중(현시점기준)",
                                    "매출 5억 달성",
                                    "2차전지, 디스플레이, 반도체 관련 장비 업체",
                                    "5군데 협력 업체 등록",
                                ]}
                            />
                            <HistoryList
                                year="2021.03"
                                contents={["The Engineer 홈페이지 개설", "The Engineer 네이버 블로그 개설"]}
                            />
                            <HistoryList year="2021.04" contents={["에스피투로보틱스 MOU체결"]} />
                        </div>
                    </div>
                    {/* <button className={style["button--history-more"]} onClick={() => setOpen((prev) => !prev)}>
                        더보기
                    </button> */}
                    <button
                        className={style["button--about"]}
                        onClick={() => setOpen((prev) => !prev)}
                        style={{ margin: "48px auto 0px" }}
                    >
                        더보기
                    </button>
                </div>
            </div>
            {createPortal(
                <CSSTransition in={open} timeout={400} classNames="popup-fade" unmountOnExit nodeRef={container}>
                    <div
                        className={popup["div--popup"]}
                        ref={container}
                        onClick={(e) => {
                            if (document.querySelector(".container-sheet")?.contains(e.target as Node)) return;
                            setOpen(false);
                        }}
                    >
                        <div className={`${popup["container--popup"]} container-sheet`}>
                            <button className={popup["button--popup"]} onClick={() => setOpen(false)}>
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="#D6D6D6"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M16 7.51H10.25V1.75C10.25 1.35218 10.092 0.970644 9.81066 0.68934C9.52936 0.408035 9.14782 0.25 8.75 0.25C8.35218 0.25 7.97064 0.408035 7.68934 0.68934C7.40804 0.970644 7.25 1.35218 7.25 1.75V7.5H1.5C1.10218 7.5 0.720644 7.65804 0.43934 7.93934C0.158035 8.22064 0 8.60218 0 9C0 9.39782 0.158035 9.77936 0.43934 10.0607C0.720644 10.342 1.10218 10.5 1.5 10.5H7.25V16.25C7.25 16.6478 7.40804 17.0294 7.68934 17.3107C7.97064 17.592 8.35218 17.75 8.75 17.75C9.14782 17.75 9.52936 17.592 9.81066 17.3107C10.092 17.0294 10.25 16.6478 10.25 16.25V10.5H16C16.3978 10.5 16.7794 10.342 17.0607 10.0607C17.342 9.77936 17.5 9.39782 17.5 9C17.5 8.60218 17.342 8.22064 17.0607 7.93934C16.7794 7.65804 16.3978 7.5 16 7.5V7.51Z" />
                                </svg>
                            </button>
                            <div>
                                {popupHistoryItems.map((item, index) => (
                                    <HistoryList
                                        key={item.id ?? `${item.year}-${index}`}
                                        year={item.year}
                                        contents={item.contents}
                                    />
                                ))}
                                {!isHistoryLoading && popupHistoryItems.length === 0 && (
                                    <p className={style["text--content--copy"]}>현재 등록된 연혁이 없습니다.</p>
                                )}
                            </div>
                        </div>
                    </div>
                </CSSTransition>,
                document.body
            )}
        </>
    );
};
const HistoryList = ({ year, contents }: { year: string; contents: string[] }) => {
    return (
        <div className={style["unit--history-list"]}>
            <div className={style["text--history-list--year"]}>{year}</div>
            <ul className={style["text--history-list--content"]}>
                {contents.map((content, i) => (
                    <li key={`history-${i}`}>{content}</li>
                ))}
            </ul>
        </div>
    );
};

const Xconcep = () => {
    return (
        <div className={style["container--x-concep"]}>
            <div className={style["unit--x-concep--background"]}></div>
            <div className={style["unit--x-concep--cover"]}></div>
            <div className={style["unit--content"]}>
                <h4 className={style["text--x-concep--head"]}>아이디어가 현실이 되는 순간</h4>
                <h4 className={style["text--x-concep--copy"]}>
                    누구나 쉽고, 빠르게 복잡하고 비싼 초기 설계 과정을 AI가 대신합니다
                    <br />
                    오직 아이디어와 텍스트만으로 당신의 상상이 즉시 설계도면으로 완성됩니다
                </h4>
                <a className={style["button--x-concep"]} href="https://xconcepai.com/" target="_blank">
                    Right now
                </a>
            </div>
        </div>
    );
};

var tween = (scrollTarget: number, from: number, to: number, value: number) => {
    if (scrollTarget < from) {
        return 0;
    } else if (scrollTarget > to) {
        return value;
    } else {
        return ((easeInOut(scrollTarget / to) * value) / (to - from)) * (scrollTarget - from);
        // return value / (to - from) * (scrollTarget - from);
    }
};
var easeInOut = (x: number) => {
    return 1 - Math.pow(1 - x, 8);
};
